/**
 * Body of the first deposit of a template: `multipart/form-data`. `documentTypeId` travels as the
 * type's numeric identifier — multipart has no native number type, so it is converted to a
 * string on append. `description` is omitted entirely when empty or absent: an empty field has
 * nothing to transmit. `reevaluationSectionKeys` travels as JSON text (multipart has no array type)
 * and is omitted when empty.
 */
class CreateDocumentTemplate {
	constructor(
		public readonly organizationId: number,
		public readonly name: string,
		public readonly documentTypeId: number,
		public readonly description: string | null,
		public readonly file: File,
		public readonly reevaluationSectionKeys: readonly string[] = [],
	) {
		Object.freeze(this);
	}

	toFormData(): FormData {
		const formData = new FormData();
		formData.append('file', this.file);
		formData.append('name', this.name);
		formData.append('documentTypeId', String(this.documentTypeId));

		if (this.description !== null && this.description.length > 0) {
			formData.append('description', this.description);
		}

		if (this.reevaluationSectionKeys.length > 0) {
			formData.append('reevaluationSectionKeys', JSON.stringify(this.reevaluationSectionKeys));
		}

		return formData;
	}
}

export default CreateDocumentTemplate;
